// hooks
import useAudit from 'hooks/useAudit'
import useForToday from 'hooks/useForToday'
import useHabits from 'modules/Habits/hooks/useHabits'
import useUIActions from 'hooks/useUIActions'
// utils
import normalizeText from 'utils/normalizeText'
import sendGaPush from 'utils/sendGaPush'
import Image from 'components/atoms/Image/image'
import ButtonLike from 'components/atoms/button-like/button-like'
import Button from 'components/atoms/button/button'
import Card from 'components/atoms/card/card'
// icons
import { PlayIcon, TimeIcon, CloseIcon } from 'components/atoms/icons/'
// components
import RichText from 'components/atoms/rich-text/rich-text'
import Video from 'modules/Programs/components/atoms/video/video'
// types
import typesSlideOverlay from 'components/organisms/slide-overlay/types-slide-overlay'
import ButtonCheckDone from 'components/molecules/button-check-done/button-check-done'
import CardOverlay from 'components/molecules/cards/card-overlay/card-overlay'
import FormChallenge from 'components/molecules/forms/form-challenge/form-challenge'
import './habits-inside.scss'
import { useState, useEffect, useRef } from 'react'
// libraries
import Slider from 'react-slick'

const HabitsInside = props => {
	const { beneficioCollection: { items } = {}, id = false, dimension, currentPosition } = props

	// hooks
	const { showOverlay } = useUIActions()
	const { challengesList: forTodayChallengeList } = useForToday()
	const { handleActivateChallenge, setFavorites, fakeActive, isHabitLoading, favoriteData } =
		useHabits({
			listActive: forTodayChallengeList,
			dimension
		})
	const { events, handledSaveEventRegistry } = useAudit()

	// content section
	const selectContent = ({ isId, isItem, isProps }) => {
		if (isId) {
			const item = items.find(e => e.idReto === isId)
			if (item) return item
		}
		if (isItem && isItem.length > 0) return isItem[0]
		return isProps || false
	}
	const selectContentSlider = ({ isId, isItem }) => {
		if (isId && isItem) {
			return items.filter(e => e.idReto !== isId)
		}
		if (isItem) return items.slice(1)
	}

	const content = selectContent({ isId: id, isItem: items, isProps: props })
	const contentSlider = selectContentSlider({ isId: id, isItem: items })
	const {
		tituloGeneral,
		descripcionGeneral,
		descripcionDelReto,
		imagen,
		formatoReto,
		linkSecundario,
		idReto,
		subTitle = false
	} = content || false

	// favorite
	const isFavorite =
		(favoriteData &&
			favoriteData.some(e => parseInt(e.contentfulFavoriteId) === parseInt(idReto))) ||
		false

	const favoriteToSetData = {
		favoriteName: tituloGeneral,
		favoriteDimension: dimension,
		contentfulFavoriteId: idReto
	}

	// constants
	const [isFullScreen, setFullScreen] = useState(false)
	const videoElement = useRef()
	const normalizeReto = normalizeText(formatoReto)
	const isChallengeDone = fakeActive.some(j => j.challengeMoment === idReto)

	// slider settings
	const sliderSettings = {
		arrows: false,
		dots: false,
		infinite: false,
		speed: 200,
		slidesToShow: 1.8,
		slidesToScroll: 1,
		className: 'full-slider'
	}

	// actions
	const openFullScreen = elem => {
		setFullScreen(true)
		if (!elem) return
		elem.currentTime = 0
		if (elem.requestFullscreen) {
			return elem.requestFullscreen()
		}
		if (elem.webkitRequestFullscreen) {
			/* Safari */
			return elem.webkitRequestFullscreen()
		}
		if (elem.msRequestFullscreen) {
			/* IE11 */
			return elem.msRequestFullscreen()
		}
	}

	const closeFullScreen = () => {
		if (!window.screen) return

		if ((window.screen.availHeight || window.screen.height - 30) <= window.innerHeight) {
			return setFullScreen(false)
		}
	}

	// metrics
	const handleSendGaPush = ({ action = 'ClicHabitos', label }) => {
		sendGaPush({ category: 'SaludContinuarediseno', action, label })
	}

	const setVideo = ({ url }) => {
		if (!url) return new Error('Se necesita la URL para reproducir el vídeo:', url)
		return (
			isFullScreen && (
				<div className={`m-habits-inside__video__modal ${isFullScreen ? 'open' : ''} `}>
					<button
						className='m-habits-inside__video__modal__close'
						onClick={() => setFullScreen(false)}
					>
						<CloseIcon color='#ee2b7b' />
					</button>
					<Video urlVideo={url} />
				</div>
			)
		)
	}

	useEffect(() => {
		closeFullScreen()
	}, [screen.availHeight])

	return (
		<CardOverlay
			headerContent={
				<>
					{/* // video  */}
					{normalizeReto === 'video' &&
						setVideo({
							url: linkSecundario
						})}
					{normalizeReto === 'video' && (
						<button
							className='m-habits-inside__play'
							onClick={() => {
								handleSendGaPush({ label: `Play - video - ${tituloGeneral}` })
								openFullScreen(videoElement.current)
								handledSaveEventRegistry({
									eventName: events[9],
									caller: linkSecundario.split('/').slice(-1)[0],
									trackTime: true,
									timeSpent: 1
								})
							}}
							style={{ top: `calc(${currentPosition}vh - 4rem)` }}
						>
							<PlayIcon color='#fff' />
						</button>
					)}
					<ButtonCheckDone active={isChallengeDone} />
					<ButtonLike
						active={isFavorite}
						classes='m-habits-inside__like'
						setFavorite={setFavorites}
						dataToSet={favoriteToSetData}
						size='3.5rem'
					/>
				</>
			}
			img={imagen && imagen.url}
		>
			<section className='m-habits-inside'>
				<div className='container pb0'>
					<h3>{tituloGeneral}</h3>
					{subTitle && <p className='c-magenta mb1'>{subTitle}</p>}
					{normalizeReto === 'podcast' && linkSecundario && (
						<div className='mb2'>
							<iframe
								src={linkSecundario}
								title='Podcast Comfama Salud Continua'
								width='100%'
								height='250'
								frameBorder='0'
								allow='encrypted-media'
							/>
						</div>
					)}

					{descripcionGeneral && <p>{descripcionGeneral}</p>}

					{(normalizeReto === 'lectura' || normalizeReto === 'articulo') && descripcionDelReto && (
						<RichText data={descripcionDelReto} isContent />
					)}
				</div>

				<FormChallenge
					isLoading={isHabitLoading}
					itsDone={isChallengeDone}
					onComplete={handleActivateChallenge}
					data={{ ...content, dimension }}
				/>

				{contentSlider && contentSlider.length > 0 && (
					<div className='container'>
						<h4>Retos</h4>
						<Slider {...sliderSettings}>
							{contentSlider.map(card => (
								<div key={card.idReto} className='m-habits-inside__card_slider'>
									<Card>
										<Image height='180' src={card.imagen.url} alt={card.tituloGeneral} />
										<ButtonCheckDone
											active={fakeActive.find(j => j.challengeMoment === card.idReto)}
										/>
										<div className='m-habits-inside__card_slider__body'>
											<header>
												{card.tituloGeneral && <h4>{card.tituloGeneral}</h4>}
												{card.duracionDelReto && (
													<span className='c-magenta'>
														<TimeIcon color='#EE2B7B' />
														{card.duracionDelReto}
													</span>
												)}
											</header>
											{card.descripcionGeneral && (
												<p className='m-habits-inside__card_slider__body__text'>
													{card.descripcionGeneral}
												</p>
											)}
										</div>
									</Card>
									<Button
										title={card.textoBoton}
										classes='m-habits-inside__card_slider__body__button pink small fit'
										onClick={() => {
											showOverlay({
												open: true,
												element: props,
												id: card.idReto,
												template: typesSlideOverlay.habits
											})
										}}
									/>
								</div>
							))}
						</Slider>
					</div>
				)}
			</section>
		</CardOverlay>
	)
}

export default HabitsInside
